export const FOOD_SIDEBAR_SCROLL_TO_BUTTOM = "FOOD_SIDEBAR_SCROLL_TO_BUTTOM"
export const ADD_FOOD_PAGE_SIDEBAR_REF = "ADD_FOOD_PAGE_SIDEBAR_REF"